/**
 * Legacy Beatly web app (pre-Omni) base URL for redirect-with-JWT flows.
 */

export function getLegacyAppOrigin(): string {
  const env = import.meta.env.VITE_ENVIRONMENT;
  if (env === 'production') {
    return 'https://app.beatly.com';
  }
  return 'https://app.staging.beatly.com';
}

export function buildLegacyAppUrl(token?: string): string {
  const url = new URL(getLegacyAppOrigin());
  if (token) {
    url.searchParams.set('jwt', token);
  }
  return url.toString();
}
